import i18n from '@/utils/i18n';
import React from 'react';
import { formatCurrency } from '@/utils/money';
import { formatSummaryDateWithYear } from '@/utils/date';
import { PaymentBatchStatus } from '@/enums';
import { PaymentHistoryListFieldsFragment } from '@/types';
import { PaymentsListItem } from './payments-list-item';
import { PaymentStatusCard } from './payment-status-card';
import { StyleProp, ViewStyle } from 'react-native';
import { Typography, TypographyVariant } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  currencyCode: string | null;
  isSelected?: boolean;
  onPress: () => void;
  payment: PaymentHistoryListFieldsFragment;
  topLeftTypography?: TypographyVariant;
  topRightTypography?: TypographyVariant;
}

export const PaymentHistoryListItem: React.FC<Props> = ({
  containerStyle,
  currencyCode,
  isSelected,
  onPress,
  payment,
  topLeftTypography = 'paragraph-base-600',
  topRightTypography = 'paragraph-base',
}) => {
  const theme = useTheme();

  return (
    <PaymentsListItem
      bottomLeft={
        <PaymentStatusCard
          createdAt={new Date(payment.created_at)}
          status={payment.status as PaymentBatchStatus}
        />
      }
      containerStyle={containerStyle}
      isSelected={isSelected}
      onPress={onPress}
      testID="payment-history-list-item"
      topLeft={
        <Typography
          color={theme.sk.color.text.primary}
          variant={topLeftTypography}
        >
          {i18n.t('payment_paid_date', {
            date: formatSummaryDateWithYear(
              payment.link_paid_at || payment.created_at,
            ),
          })}
        </Typography>
      }
      topRight={
        <Typography
          color={theme.sk.color.text.primary}
          variant={topRightTypography}
        >
          {formatCurrency(
            payment.payment_batch_amount?.charged_amount_in_micros!,
            currencyCode,
          )}
        </Typography>
      }
    />
  );
};
